import React from 'react';
import styled from 'styled-components';
import { cssColorValue, semanticColors } from '@spotify-internal/encore-web';

import { ParentCategory } from 'lib/sanity/types';
import { ParentCategoryLink, omitClassName } from 'components/Links';
import { UbiHomePage } from 'utils/ubi/pages/useUbiHome';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { Vertical } from 'utils/vertical';

import { SideImageCategoryCard } from './SideImageCategoryCard';
import { CategoryCardComponent } from './CategoryCardComponent';
import { TopImageCategoryCard } from './TopImageCategoryCard';

const CardLink = styled.a`
  text-decoration: none;
  color: ${cssColorValue(semanticColors.textBase)};
`;

export interface CategoryCardProps {
  category: ParentCategory;
  index: number;
  ubi: UbiHomePage;
}

const variants: Record<Vertical, CategoryCardComponent> = {
  [Vertical.ARTISTS]: TopImageCategoryCard,
  [Vertical.CONSUMER]: SideImageCategoryCard,
  [Vertical.PODCASTERS]: TopImageCategoryCard,
  [Vertical.FINDAWAY]: TopImageCategoryCard,
};

const CategoryCard = ({ category, ubi, index }: CategoryCardProps) => {
  const {
    verticalConfig: { verticalName },
  } = useServerSideConstants();
  const Variant = variants[verticalName];

  return (
    <div role="listitem" data-testid={`categoryCard-${category.title}`}>
      <ParentCategoryLink
        parentCategorySlug={category.slug}
        eventDefinition={{
          category: 'category_card',
          action: category.slug,
          label: 'home_page',
          value: undefined,
        }}
        ubiFactory={ubi.logCategoryCardLink(category.slug, index)}
        component={omitClassName(CardLink)}
      >
        <Variant category={category} vertical={verticalName} />
      </ParentCategoryLink>
    </div>
  );
};

export default CategoryCard;
